import actionTypes from './actionTypes';

export const approve = (profileId, doc, values) => ({
  type: actionTypes.APPROVE,
  payload: {
    doc,
    values,
    profileId,
  },
});

export const approved = doc => ({
  type: actionTypes.APPROVED,
  payload: {
    doc,
  },
});

export const reject = (profileId, doc, values) => ({
  type: actionTypes.REJECT,
  payload: {
    doc,
    values,
    profileId,
  },
});

export const rejected = doc => ({
  type: actionTypes.REJECTED,
  payload: {
    doc,
  },
});
